import Drawer from "../../../../drawer/Drawer";
import ManageTicket from "../ManageTicket";

const ManageTicketDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl6"}
      size={"xl2"}
      title={<span className="tracking-tighter uppercase">Ticket Details</span>}
      subtitle="View information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <ManageTicket getResponse={getResponse} close={close} data={data} />
      </div>
    </Drawer>
  );
};

export default ManageTicketDrawer;
